import { MaskLine } from "./Motion";

export const PageHeader = ({ eyebrow, title, italicTitle, intro }) => (
  <section className="pt-40 md:pt-48 pb-16 md:pb-24 max-w-7xl mx-auto px-6 lg:px-10">
    <p className="label text-sage mb-6 flex items-center gap-3">
      <span className="w-8 h-px bg-sage/60" /> {eyebrow}
    </p>
    <h1 className="font-serif text-navy-deep text-5xl sm:text-6xl lg:text-7xl font-medium tracking-tight leading-[1.06]">
      <MaskLine delay={0.15}>{title}</MaskLine>
      {italicTitle && <MaskLine delay={0.3} className="italic text-navy">{italicTitle}</MaskLine>}
    </h1>
    {intro && (
      <p className="mt-8 max-w-2xl text-lg md:text-xl text-navy-deep/70 leading-relaxed">{intro}</p>
    )}
  </section>
);
